import store     from '../../app/store/index.js';
import virusTrip from './store/virus-trip-module.js';

const moduleList = [ {
  path       : 'virusTrip',
  moduleName : virusTrip
} ];

moduleList.map( ( { path, moduleName } ) => {
  store.registerModule( path, moduleName );
} );

export default store;



// WEBPACK FOOTER //
// ./src/projects/virusTrip/store.js